// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__1vOz5","logout":"Navigation_logout__3T5Hr"};